export default __webpack_public_path__ + "static/media/6.fac66801.svg";